import { isServerError } from 'src/hooks/use-axios';
import { NotFound } from 'src/utils/errors';
import { handleError } from 'src/utils/handle-error';
import { reportToSentry } from 'src/utils/report-to-sentry';

export const handleUmmRelatedError = (error: unknown) => {
  if (isServerError(error, 404) || error instanceof NotFound) throw error;

  const [_, report] = handleError(error, () => {});
  if (report) reportToSentry(error);
  return error;
};
